export default __webpack_public_path__ + "static/media/corn.ad8e31d6.svg";